import State from './state';
import ListView from './state/list_view';
import Rank from './state/rank';
import User from './state/user';
import Voice from './state/voice';

const state = new State();
const listView = new ListView();
const rank = new Rank();
const user = new User();
const voice = new Voice();

export default {
    state,
    listView,
    rank,
    user,
    voice
}
